import React, { Component } from 'react'
import Button from 'react-bootstrap/Button'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ImageUploader from 'react-images-upload'
import { Document, Page } from 'react-pdf'
import SignatureCanvas from 'react-signature-canvas'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons'
import Description from '../../task/Description'

import './SignAgreement.css'

class SignAgreement extends Component {
  constructor(props) {
    super(props)

    this.state = {
      pageNumber: null,
      numPages: null,
      mode: 'touch',
      signature: null,
      signatureBuffers: {},
      uploaded: null,
      windowSize: {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      },
    }
    this.rootRef = React.createRef()
    this.signatureCanvasRef = React.createRef()
    this.handleResize = () => this.setState({
      windowSize: {
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight,
      },
    })
  }

  componentDidMount() {
    if (this.props.storage && this.state.uploaded === null) {
      this.loadFiles()
    }
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }

  componentDidUpdate() {
    if (this.props.storage && this.state.uploaded === null) {
      this.loadFiles()
    }
  }

  loadFiles() {
    this.performLoadFiles()
      .then((uploaded) => {
        this.setState({ uploaded, })
      })
      .catch((error) => this.showError(error))
  }

  isFilesUploaded() {
    const { uploaded } = this.state
    if (!uploaded) {
      return false
    }
    if (this.state.mode === 'photo' &&
      Object.keys(uploaded).filter((key) => key.startsWith('photo-')).length > 0) {
      return true
    }
    if (this.state.mode === 'touch') {
      return (this.props.requirement.subjects ||[]).every((subject) => uploaded[`touch-${subject}.dat`])
    }
    return false
  }

  confirmRequirement() {
    if (!this.props.onAgree) {
      return;
    }
    const files = Object.keys(this.state.uploaded)
      .filter((key) => key.startsWith(this.state.mode))
      .map((key) => this.state.uploaded[key].path)
    this.props.onAgree({ files, mode: this.state.mode, updated: Date.now(), })
  }

  processFiles(pictureFiles, pictureDataURLs) {
    this.uploadFiles(pictureFiles)
      .then((files) => {
        const uploaded = {}
        Object.keys(this.state.uploaded || {})
          .filter((key) => !key.startsWith('photo-'))
          .forEach((key) => {
            uploaded[key] = this.state.uploaded[key]
          })
        files.forEach((file) => {
          const path = file.path.split('/')
          uploaded[path[path.length - 1]] = file
        })
        this.setState({ uploaded, })
      })
      .catch((error) => this.showError(error))
  }

  showError(error) {
    if (!this.props.onError) {
      console.error(error)
      return
    }
    this.props.onError(error)
  }

  async performLoadFiles() {
    const { storage, user, agreement, requirement } = this.props
    const path = `user/${user.uid}/agreement/${agreement.id}/${requirement.id}`
    const files = await storage.ref(path).listAll()
    const urls = await Promise.all(files.items.map((item) => storage.ref(item.fullPath).getDownloadURL()))
    const uploaded = {}
    files.items.forEach((item, index) => {
      uploaded[item.name] = { path: item.fullPath, url: urls[index] }
    })
    return uploaded
  }

  async uploadFiles(pictureFiles) {
    return await Promise.all(pictureFiles.map((pictureFile, index) => this.uploadFile(pictureFile, index)))
  }

  async uploadFile(pictureFile, index) {
    const { storage, user, agreement, requirement } = this.props
    const path = `user/${user.uid}/agreement/${agreement.id}/${requirement.id}/photo-${index}.dat`
    await storage
      .ref(path)
      .put(pictureFile, {
        contentType: pictureFile.type
      })
    const url = await storage.ref(path).getDownloadURL()
    return { path, url }
  }

  async uploadSignature(subject, dataURL) {
    const { storage, user, agreement, requirement } = this.props
    const path = `user/${user.uid}/agreement/${agreement.id}/${requirement.id}/touch-${subject}.dat`
    await storage
      .ref(path)
      .putString(dataURL, 'data_url')
    const url = await storage.ref(path).getDownloadURL()
    return { path, url }
  }

  finishSignature() {
    if (!this.signatureCanvasRef.current) {
      throw new Error('Invalid state')
    }
    const dataURL = this.signatureCanvasRef.current.getTrimmedCanvas().toDataURL('image/png')
    this.uploadSignature(this.state.signature, dataURL)
      .then((file) => {
        const signatureBuffers = Object.assign({}, this.state.signatureBuffers)
        signatureBuffers[this.state.signature] = dataURL
        const uploaded = Object.assign({}, this.state.uploaded || {})
        const path = file.path.split('/')
        uploaded[path[path.length - 1]] = file
        this.setState({
          signature: null,
          signatureBuffers,
          uploaded,
        })
      })
      .catch((error) => this.showError(error))
  }

  getUploadedSignature(subject) {
    const { uploaded } = this.state
    if (!uploaded) {
      return null
    }
    const file = uploaded[`touch-${subject}.dat`]
    if (!file) {
      return null
    }
    return file.url
  }

  getCanvasProps() {
    const width = parseInt(this.state.windowSize.innerWidth * 0.95)
    const height = parseInt(this.state.windowSize.innerHeight * 0.95) - 36
    return { width, height, style: { width: `${width}px`, height: `${height}px` } }
  }

  renderSignatureCanvas() {
    const { requirement } = this.props
    return ((requirement.subjects || []).map((subject) => <Row className='SignInput'>
      <Col sm='auto' className='align-self-end'>
        <h5>{subject}</h5>
      </Col>
      <Col sm={8} className='SignCanvasContainerCol'>
        {this.state.signature !== subject && (this.state.signatureBuffers[subject] || this.getUploadedSignature(subject)) &&
          <img src={this.state.signatureBuffers[subject] || this.getUploadedSignature(subject)} alt='署名' />}
      </Col>
      <Col sm='auto' className='align-self-end'>
        {!this.state.signature && !this.props.uploaded && <Button
            data-test-sign-agreement-input={subject}
            variant='success'
            onClick={() => this.setState({
              signature: subject,
              signatureFilled: false,
            })}
          >
            タッチパネルで入力
          </Button>}
      </Col>
      {this.state.signature === subject && this.renderSignatureModal(subject)}
    </Row>))
  }

  renderSignatureModal(subject) {
    return (<div className='SignCanvasModal'>
      <div className='SignCanvasDescription'>タッチパネルで署名してください。画面に書きやすい方向で書いてください。 ({subject})</div>
      <div className='SignCanvasContainer'>
        <SignatureCanvas
          ref={this.signatureCanvasRef}
          penColor='black'
          canvasProps={this.getCanvasProps()}
          clearOnResize={false}
          onEnd={() => this.setState({
            signatureFilled: true,
          })}
        />
      </div>
      <div className='SignCanvasButtons'>
        <Button
            data-test-sign-agreement-cancel={subject}
            variant='default'
            onClick={() => this.setState({
              signature: null,
            })}
          >
            キャンセル
        </Button>
        <Button
            data-test-sign-agreement-complete={subject}
            variant='success'
            disabled={!this.state.signatureFilled}
            onClick={() => this.finishSignature()}
          >
            完了
        </Button>
      </div>
    </div>)
  }

  renderUploadedPhoto() {
    const { uploaded } = this.state
    if (!uploaded) {
      return null
    }
    const keys = Object.keys(uploaded).filter((key) => key.startsWith('photo-'))
    if (keys.length === 0) {
      return null
    }
    return <img src={uploaded[keys[0]].url} alt='uploaded' width='300' />
  }

  getUploadedMode() {
    if (!this.props.uploaded) {
      return null
    }
    return this.props.uploaded.mode
  }

  render() {
    const { requirement, uploaded } = this.props
    return <div className='PDFAgreementRoot' ref={this.rootRef}>
      <Tabs
        activeKey={this.getUploadedMode() || this.state.mode}
        onSelect={(key) => this.setState({ mode: key })}
      >
        <Tab
          eventKey='touch'
          title='タッチで署名'
        >
          以下をお読みの上、タッチパネルで署名をしてください。
          <Document
            file={requirement.src}
            onLoadSuccess={({ numPages }) => this.setState({
              numPages,
              pageNumber: 1,
              pageWidth: this.rootRef.current.clientWidth * 0.8,
            })}
            disabled={this.getUploadedMode() && this.getUploadedMode() !== 'touch'}
          >
            <Page
              className='SignAgreementDocument'
              pageNumber={this.state.pageNumber}
              width={this.state.pageWidth}
            />
          </Document>
          {this.state.numPages && <div className='PDFAgreementPages'>
              <FontAwesomeIcon
                className='PDFPageControl PDFPagePrevious'
                onClick={() => this.setState({
                  pageNumber: Math.max(this.state.pageNumber - 1, 1),
                })}
                icon={faAngleLeft}
              />
              {this.state.pageNumber} / {this.state.numPages}
              <FontAwesomeIcon
                className='PDFPageControl PDFPageNext'
                onClick={() => this.setState({
                  pageNumber: Math.min(this.state.pageNumber + 1, this.state.numPages),
                })}
                icon={faAngleRight}
              />
            </div>}
          {requirement.agreement && <Description markdown={requirement.agreement} />}
          {this.renderSignatureCanvas()}
        </Tab>
        <Tab
          eventKey='photo'
          title='署名して撮影'
          disabled={this.getUploadedMode() && this.getUploadedMode() !== 'photo'}
        >
          <a href={requirement.src} target='_blank' rel='noopener noreferrer'>同意書</a>
          をダウンロード、印刷の上、署名欄に{(requirement.subjects || []).join(', ')}の署名を記入してください。完了したら、同意書を以下のボタンで撮影しアップロードしてください。
          <ImageUploader
            data-test-sign-agreement-upload-photo
            withIcon={true}
            buttonText='画像をアップロード'
            withPreview={false}
            singleImage={true}
            onChange={(pictureFiles, pictureDataURLs) => this.processFiles(pictureFiles, pictureDataURLs)}
            imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif"]}
            maxFileSize={52428800}
          />
          {this.renderUploadedPhoto()}
        </Tab>
      </Tabs>
      <div className='SignAgreementControls'>
        {uploaded && <div className='SignAgreementAgreed'>
            提出済みです。
          </div>}
        {!uploaded && this.isFilesUploaded() && !this.state.signature &&
          <Row className='SignAgreementControlsRow'>
            <Col sm={10}>
              これでよろしければ、提出ボタンを押してください。
            </Col>
            <Col sm='auto'>
              <Button
                data-test-sign-agreement-confirm
                variant='success'
                onClick={() => this.confirmRequirement()}
              >
                提出
              </Button>
            </Col>
          </Row>}
      </div>
    </div>
  }
}

export default SignAgreement;
